import * as yup from 'yup';

import { InvalidTypeValueError } from 'activate-errors';
import { NumberTypeBase } from '../../types/baseTypes/NumberTypeBase';
import { TypeContextEnum } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_OTHER } from '../constants';

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use EmType from application-types instead.
 */
export class EmType extends NumberTypeBase {
  group = TYPE_GROUP_OTHER;

  name = 'Em';

  get example() {
    return 5;
  }

  get default(): any {
    return 0;
  }

  friendlyName = 'Em';

  contexts = [TypeContextEnum.Block];

  superUserOnly = true;

  buildSchema() {
    return yup.number().nullable();
  }

  deserialize = (value: any) => {
    if (value === undefined || value === null) {
      return value;
    }

    if (typeof value === 'number') {
      return value;
    }

    if (typeof value === 'string') {
      return Number.parseFloat(value);
    }

    throw new InvalidTypeValueError(`${value} for Em is not valid.`);
  };

  parseValue = (value: any) => `${value}em`;
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use Em from application-types instead.
 */
const definition = new EmType();

Types.addBaseType(definition);
export default definition;
